import React from 'react'
import ExportModal from '../../../Components/ExportModal'

export default function ExportMenuItemSalesModal({ onClose }) {
  return (
    <ExportModal
      title="Export Menu Item Sales"
      exportUrl="/manage/menu_items/export"
      onClose={onClose}
    />
  )
}
